/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export interface ChatButtonSignature {
  // The arguments accepted by the component
  Args: {
    onClick: () => void;
    isDisabled?: boolean;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

// export default templateOnly<ChatButtonSignature>();
export default class ChatButtonComponent extends Component<ChatButtonSignature> {
  @tracked
  showChat = false;

  @action
  toggleChat() {
    this.showChat = !this.showChat;
  }
}
